import 'antd/lib/date-picker/style/index.css'
import dayjs from 'dayjs'
import dayjsGenerateConfig from 'rc-picker/lib/generate/dayjs'

import generatePicker from 'antd/lib/date-picker/generatePicker'

import 'dayjs/locale/ko'
dayjs.locale('ko')

const CustomDatePicker = generatePicker(dayjsGenerateConfig)
export default CustomDatePicker
